export const getPatientAnalysesData = state => state.patientAnalyses.all;
export const getPatientAnalysisData = state => state.patientAnalyses.patientAnalysis;
export const patientAnalysesIsFetching = state => state.patientAnalyses.loading.all;
export const patientAnalysisIsFetching = state => state.patientAnalyses.loading.patientAnalysis;
